import { ApiService } from "./ApiService";

export class EmbedService extends ApiService {
  getEmbedDetails(token) {
    return this.apiRequestGet(`embeds/public/${token}`);
  }
}
